import { render, staticRenderFns } from "./userRights.vue?vue&type=template&id=5865bbd5&scoped=true&"
import script from "./userRights.vue?vue&type=script&lang=js&"
export * from "./userRights.vue?vue&type=script&lang=js&"
import style0 from "./userRights.vue?vue&type=style&index=0&id=5865bbd5&lang=scss&scoped=true&"
import style1 from "./userRights.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./userRights.vue?vue&type=style&index=2&id=5865bbd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865bbd5",
  null
  
)

export default component.exports